import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { LocalBasketItem } from '../../customer/basket/basket-item.decorator';
import { LocalBasket } from '../local-basket';

export namespace NRewardBanner {
    export const BLOCK_ID = 'reward-banner';

    export interface IBlockDataContent {
        message?: string;
    }
}

@ICmsComponent<RewardBannerComponent>({
    id: NRewardBanner.BLOCK_ID,
    block: {
        url: NRewardBanner.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Reward Banner',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'message',
            title: 'Message',
            required: true,
            default: 'My Reward Item(s) added'
        }
    ]
})
@Component({
    selector: 'reward-banner',
    templateUrl: './reward-banner.html',
    styleUrls: ['./reward-banner.scss'],
    standalone: true,
    imports: [TranslationModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RewardBannerComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit, OnDestroy {
    private readonly basket = inject(LocalBasket);

    @ICmsContent({
        type: 'blockContent'
    })
    content!: NRewardBanner.IBlockDataContent;

    get hasRewardItems(): boolean {
        return (this.basket.items as LocalBasketItem[]).some(item => item.isReward);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(
            this.basket.subscribe(() => {
                this.detectChanges();
            })
        );
    }
}
